import { CxsBasket, UpdateBasketRequest } from '../model';

export const mapBasketToUpdate = (basket: CxsBasket): UpdateBasketRequest => ({
    basketId: basket.basketId as string,
    lines: basket.lines
        .filter(({ lineType }) => lineType === 'Normal' || lineType === 'OutOfStockRange')
        .map(({ variantNo, quantity, giftWrappings, giftWrappingsCard, giftWrappingsCardText }) => ({
            variantNo,
            quantity,
            giftWrappings,
            giftWrappingsCard,
            giftWrappingsCardText
        })),
    usePoints: basket.usePoints,
    couponCodes: basket.couponCodes,
    giftCardCodes: basket.giftCardCodes,
    zipCode: basket.zipCode,
    deliveryMethod: basket.deliveryMethod
});
